module.exports = '1.1.4';



//////////////////
// WEBPACK FOOTER
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/~/sockjs-client/lib/version.js
// module id = WkGo
// module chunks = 5